module.exports = __webpack_public_path__ + "assets/img/zh-Hant-47873996.png";